import { ReactNode } from "react";
import { cn } from "@/core/helpers/cn";
import { ChatTarget } from "@/domains/chat/constants/chat";

type Props = {
  children: ReactNode;
  target: ChatTarget;
  className?: string;
  isOpacityMode?: boolean;
};

export default function ChatBorderMessage({ children, className, target, isOpacityMode }: Props) {
  return (
    <div
      className={cn(
        "relative w-full rounded-[0.5rem] overflow-clip bg-gradient-to-r transition",
        isOpacityMode ? "from-dark-900/40 to-transparent" : "from-dark-900/80 to-dark-900/60",
        className,
      )}
    >
      <div
        className={cn(
          "absolute left-0 h-full w-[1rem]",
          "border-l-2 rounded-[0.5rem] overflow-clip",
          {
            "border-[#e66dec]":
              target === ChatTarget.Attempt ||
              target === ChatTarget.Emote ||
              target === ChatTarget.Scene,
            "border-red-600": target === ChatTarget.Error,
            "border-[#2C7DE8]": target === ChatTarget.Faction || target === ChatTarget.FactionOoc,
            "border-[#45D8C9]": target === ChatTarget.Family || target === ChatTarget.FamilyOoc,
            "border-[#f3ebd0]": target === ChatTarget.Native,
            "border-transparent":
              target === ChatTarget.SpeakEmote ||
              target === ChatTarget.Speaking ||
              target === ChatTarget.SpeakingOoc ||
              target === ChatTarget.Whisper ||
              target === ChatTarget.News ||
              target === ChatTarget.Shout ||
              target === ChatTarget.Government,
            "border-[#e1cf1c]": target === ChatTarget.Staff,
            "border-[#edbaba]": target === ChatTarget.ValidationError,
            "border-[#e0ffff]": target === ChatTarget.World,
          },
        )}
      />
      <div
        className={cn("px-3 py-2 bg-gradient-to-r from-[20%] to-transparent", {
          "from-[#e66dec]/20":
            target === ChatTarget.Attempt ||
            target === ChatTarget.Emote ||
            target === ChatTarget.Scene,
          "from-red-600/20": target === ChatTarget.Error,
          "from-[#2C7DE8]/30": target === ChatTarget.Faction || target === ChatTarget.FactionOoc,
          "from-[#45D8C9]/30": target === ChatTarget.Family || target === ChatTarget.FamilyOoc,
          "from-[#f3ebd0]/30": target === ChatTarget.Native,
          "from-white/20": target === ChatTarget.Shout,
          "from-transparent":
            target === ChatTarget.SpeakEmote ||
            target === ChatTarget.Speaking ||
            target === ChatTarget.SpeakingOoc ||
            target === ChatTarget.Whisper ||
            target === ChatTarget.News ||
            target === ChatTarget.Government,
          "from-[#e1cf1c]/30": target === ChatTarget.Staff,
          "from-[#edbaba]/30": target === ChatTarget.ValidationError,
          "from-[#e0ffff]/30": target === ChatTarget.World,
        })}
      >
        {children}
      </div>
    </div>
  );
}
